import { Directorios } from './../../../_entities/galeria/Directorios';
import { ListaImagenes } from './../../../_entities/galeria/ListaImagenes';
import { environment } from './../../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InMemoryWebApiModule } from 'angular-in-memory-web-api';

@Injectable({
  providedIn: 'root'
})
export class GaleriaVehiculoService {

  constructor(private http: HttpClient) { }

    /*Obtener Todas las imagenes-*/
    obtenerListaImagenes(imei): Observable<ListaImagenes[]> {
      return this.http.get<ListaImagenes[]>(environment.API_SECURITY + '/api/Imagenes', {
        params: {
          imei: imei
        }
      })
    }
  
  
    /**Obtener Imagen Especifica */
    obtenerImagenEspecifica(imei, foto) {
      return this.http.get(environment.API_SECURITY + '/api/Imagenes/ObtenerImagen', {
        responseType: 'blob', params: {
          imei: imei,
          imagen: foto
        }
      })
    }
  
    /**Obtener Galeria */
    obtenerGaleria(imei,fechaInicio,fechaFinal):Observable<ListaImagenes[]>{
      return this.http.get<ListaImagenes[]>(environment.API_SECURITY + '/api/Imagenes/Fechas',{params:{
        imei:imei,
        fechaInicial:fechaInicio,
        fechaFinal:fechaFinal
      }})
    }
  
    /**Obtener directorios por imei*/
    obtenerDirectorios(imei):Observable<Directorios[]>{
      return this.http.get<Directorios[]>(environment.API_SECURITY+'/api/Imagenes/Directorios',{params:{
        imei:imei
      }})
    }
  
    /**Obtener Archivos por directorio */
    obtenerArchivosDirectorio(imei,carpeta):Observable<ListaImagenes[]>{
      return this.http.get<ListaImagenes[]>(environment.API_SECURITY+'/api/Imagenes/',{params:{
        imei:imei,
        carpeta:carpeta
      }})
    }
  
    /**Obtener foto desde una carpeta */
    obtenerFotoCarpeta(imei,carpeta,nombre){
      return this.http.get(environment.API_SECURITY+'/api/Imagenes/ObtenerImagenCarpeta', {
        responseType: 'blob', params: {
          imei: imei,
          carpeta:carpeta,
          imagen: nombre
        }
      })
    }
    


       /**Obtener directorios por imei nuevo */
       obtenerDirectoriosNuevo(imei):Observable<Directorios[]>{
        return this.http.get<Directorios[]>(environment.API_SECURITY+'/api/Imagenes/CarpetasNuevoDispositivo',{params:{
          imei:imei
        }})
      }

      obtenerFotosDirectorioNuevo(imei,carpeta):Observable<ListaImagenes[]>{
        return this.http.get<ListaImagenes[]>(environment.API_SECURITY+'/api/Imagenes/FotosNuevoDispositivo',{params:{
          imei:imei,
          fecha:carpeta
        }})
      }

        /**Obtener Galeria */
    obtenerFoldersPorfecha(imei,fechaInicio,fechaFinal):Observable<ListaImagenes[]>{
      return this.http.get<ListaImagenes[]>(environment.API_SECURITY + '/api/Imagenes/FotosNuevoDispositivoFecha',{params:{
        imei:imei,
        fechaInicial:fechaInicio,
        fechaFinal:fechaFinal
      }})
    }
  
    
}
